import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsAcomba } from '../../hooks/useIsAcomba';
import { Button } from '../../ui/Button/Button';
import { TranslationKey } from '../../i18n/translationKeys';

interface RelanceNoAccessNoticeProps {
    testId: string;
    continueButtonTestId: string;
    onContinue: () => void;
}

/**
 * Shown in place of a sync attempt when the connected user already has no relance rights — there is
 * nothing to sync, so retrying would just fail identically. Shared by InitialSync (the "start" gate)
 * and the Onboarding walkthrough's preview screen (the "no-access" sync outcome).
 */
export const RelanceNoAccessNotice: React.FC<RelanceNoAccessNoticeProps> = ({
    testId, continueButtonTestId, onContinue,
}) => {
    const { t } = useTranslation();
    const isAcomba = useIsAcomba();

    return (
        <div data-testid={testId} className="flex flex-col items-center gap-l max-w-md text-center">
            <p className="text-primary-800 font-normal">{t(TranslationKey.InitialSync.RelanceNoAccessTitle)}</p>
            <p className="text-primary-600 text-s">
                {/* The bridge denial is an Acomba desktop security option (Customers/Customer
                    transactions/Accounts receivable); the AcceoConnect denial is the GO.Connect
                    state-of-account privilege — different products, different administrators. */}
                {t(isAcomba
                    ? TranslationKey.InitialSync.RelanceNoAccessMessage
                    : TranslationKey.InitialSync.RelanceNoAccessMessageConnect)}
            </p>
            <Button data-testid={continueButtonTestId} onClick={onContinue}>
                {t(TranslationKey.InitialSync.RelanceNoAccessContinue)}
            </Button>
        </div>
    );
};
